import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { BiDotsHorizontalRounded } from "react-icons/bi";

function DropdownCore({ children, buttonOpenModal }) {
  return (
    <Menu as="div" className="relative z-[100] inline-block text-left ">
      <div onClick={(e) => e.stopPropagation()}>
        <Menu.Button>
          {buttonOpenModal ? (
            buttonOpenModal
          ) : (
            <BiDotsHorizontalRounded size={25} color="#161F30" />
          )}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          onClick={(e) => e.stopPropagation()}
          className=" absolute top-6 z-[100] mt-1 w-44 origin-top-right rounded-md bg-white p-1.5 shadow shadow-smoot ring-1 ring-black ring-opacity-5 focus:outline-none md:w-48"
        >
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default DropdownCore;
